import AppliedAmountCellHtml from '../invoices/templates/invoice.applied-amount.cell.html'
import InvoiceLookupHtml     from '../invoices/templates/invoice.lookup.html';
import RemoveRowCellHtml     from '../../app-lite/grids/templates/cell.remove-row.html';

export function ApplyCreditsCtrl ($scope, $state, $uibModal, $translate, messages, workshopAPI, sessionObjAPI, confirm, customer, credit, credits) {
  $scope.currency = sessionObjAPI.currency();
  $scope.loaded = true;

  $scope.customer = customer;

  $scope.credits = credits || [];

  $scope.credit = credit || {};

  $scope.remainingBalance = $scope.credit.total || 0;

  $scope.invoices = [
    {
      invoice_id: '',
      invoice_number: '',
      post_date: '',
      total: 0.00,
      amount: 0.00,
      balance_due: 0.00,
      untouched: true,
      balance: function() {
        var balance_due = new BigDecimal( this.balance_due ? this.balance_due.toString(): '0' ).setScale(2, BigDecimal.ROUND_HALF_UP);
        var amount = new BigDecimal( this.amount ? this.amount.toString(): '0' ).setScale(2, BigDecimal.ROUND_HALF_UP);

        return balance_due.isLessThanOrEqualTo(BigDecimal.ZERO) ? 0: balance_due.subtract(amount).toString();
      }
    }
  ];

  $scope.creditSelected = function (credit) {
    $state.go('app.apply-credits', {
      customer_id: $scope.customer.id,
      id         : credit.id
    });
  };

  $scope.grid = {
    data                 : 'invoices',
    enableMultiSelect    : false,
    enableCellEditOnFocus: true,
    enableCellSelection  : true,
    enableRowSelection   : false,
    cellEditableCondition: '!closed',
    rowHeight            : 43,
    columnDefs           : [
      {
        enableCellEdit: false,
        cellTemplate  : RemoveRowCellHtml,
        width         : '43px'
      },
      {
        field         : 'invoice_number',
        displayName   : $translate.instant('GENERAL_SPACE.FIELD.REFERENCE'),
        enableCellEdit: false,
        cellClass     : 'Uppercase ReadOnly'
      },
      {
        field         : 'post_date',
        displayName   : $translate.instant('GENERAL_SPACE.FIELD.POST_DATE'),
        enableCellEdit: false,
        cellClass     : 'Capitalize ReadOnly',
        cellFilter    : 'date:"dd/MM/yyyy"',
        width         : '110px'
      },
      {
        field         : 'balance_due',
        displayName   : $translate.instant('GENERAL_SPACE.FIELD.BALANCE_DUE_LABEL'),
        enableCellEdit: false,
        cellClass     : 'align-right ReadOnly',
        cellFilter    : 'globalCurrency',
        width         : '125px'
      },
      {
        field               : 'amount',
        displayName         : $translate.instant('JS_SPACE.COLUMNS.APPLIED_AMOUNT'),
        enableCellEdit      : true,
        cellClass           : 'align-right',
        cellFilter          : 'globalCurrency',
        editableCellTemplate: AppliedAmountCellHtml,
        width               : '150px'
      },
      {
        field         : 'balance()',
        displayName   : $translate.instant('JS_SPACE.COLUMNS.BALANCE'),
        enableCellEdit: false,
        cellClass     : 'align-right ReadOnly',
        cellFilter    : 'globalCurrency',
        width         : '110px'
      }
    ],
  };

  $scope.validDistribution = function () {
    return $scope.remainingBalance >= 0
  };

  $scope.appliedTotal = function () {
    var total = BigDecimal.ZERO;

    angular.forEach($scope.invoices, function (invoice) {
      var amount = new BigDecimal(invoice.amount.toString()).setScale(2, BigDecimal.ROUND_HALF_UP);

      total = total.add(amount);
    });

    return total;
  };

  $scope.updateBalance = function (invoice) {
    var balance = new BigDecimal( $scope.credit.total ? $scope.credit.total.toString(): '0' ).setScale(2, BigDecimal.ROUND_HALF_UP);
    var alreadyApplied = new BigDecimal( $scope.credit.applied_credit_amount ? $scope.credit.applied_credit_amount.toString(): '0' ).setScale(2, BigDecimal.ROUND_HALF_UP);

    if (!invoice) {
      $scope.remainingBalance = balance.subtract(alreadyApplied).toString();
      return;
    }

    var amount = new BigDecimal(invoice.amount.toString()).setScale(2, BigDecimal.ROUND_HALF_UP);
    var total = $scope.appliedTotal();

    $scope.remainingBalance = balance.subtract(alreadyApplied).subtract(total).toString();
  };

  $scope.removeItem = function (row) {
    $scope.invoices.splice(row.rowIndex, 1);

    if (!$scope.invoices.length) {
      $scope.invoices.push({
        invoice_id: '',
        invoice_number: '',
        post_date: '',
        total: 0.00,
        amount: 0.00,
        balance_due: 0.00,
        untouched: true,
        balance: function() {
          var balance_due = new BigDecimal( this.balance_due ? this.balance_due.toString(): '0' ).setScale(2, BigDecimal.ROUND_HALF_UP);
          var amount = new BigDecimal( this.amount ? this.amount.toString(): '0' ).setScale(2, BigDecimal.ROUND_HALF_UP);

          return balance_due.isLessThanOrEqualTo(BigDecimal.ZERO) ? 0: balance_due.subtract(amount).toString();
        }
      })
    }
  };

  $scope.addInvoices = function () {
    var modalInstance = $uibModal.open({
      templateUrl: InvoiceLookupHtml,
      windowClass: 'lg-modal',
      controller: 'invoiceSelectionCtrl',
      resolve: {
        invoices: ['workshopAPI', function (workshopAPI) {
          return workshopAPI.get('/customers/invoice_list', [ $scope.customer.id, 0, '*', 'P', 'I', 'post_date', 'desc' ]);
        }],
        customer: function () {
          return $scope.customer;
        }
      }
    });

    modalInstance.result.then(function (invoices) {
      angular.forEach(invoices, function (invoice) {
        $scope.invoices.push({
          invoice_id: invoice.id,
          credit_id: $scope.credit.id,
          invoice_number: invoice.invoice_number,
          post_date: invoice.post_date,
          total: invoice.total,
          amount: '0',
          balance_due: invoice.balance_due,
          untouched: false,
          balance: function() {
            var balance_due = new BigDecimal( this.balance_due ? this.balance_due.toString(): '0' ).setScale(2, BigDecimal.ROUND_HALF_UP);
            var amount = new BigDecimal( this.amount ? this.amount.toString(): '0' ).setScale(2, BigDecimal.ROUND_HALF_UP);

            return balance_due.isLessThanOrEqualTo(BigDecimal.ZERO) ? 0: balance_due.subtract(amount).toString();
          }
        });

      });

      $scope.invoices = $scope.invoices.filter(function (invoice) {
        return !invoice.untouched;
      });

    });
  };

  $scope.apply = function () {
    if (parseFloat($scope.remainingBalance) < 0) {
      messages.show($translate.instant('JS_SPACE.MESSAGES.CREDIT_BALANCE_EXCEEDED'), 'error');
      return;
    }

    workshopAPI.post('/credit_application_items', $scope.invoices, 'credit_application_items', true)
      .then(function (data) {
        messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.CREDITS'), 'success');
        $scope.form.$setPristine();
        sessionObjAPI.routeTo();
      }, function (err) {
        messages.error(err);
      });

  };

  $scope.updateBalance();

}